import { useToasts } from "@certn/cascadia";
import { APIError, useAPIRequest } from "@certn/legacy-api";
import { FormikErrors, FormikHelpers, FormikValues } from "formik";
import { useTranslation } from "react-i18next";

const defaultOptions = {};

export function useFormSubmit(
  url: string,
  options: {
    onSuccess?: (values: FormikValues) => void;
    raiseError?: boolean;
  } = defaultOptions
) {
  const { t } = useTranslation();
  const { show } = useToasts();
  const request = useAPIRequest();

  return async function <T extends object>(
    values: T,
    formikHelpers: FormikHelpers<T>
  ) {
    try {
      await request(url, {
        method: "POST",
        body: JSON.stringify(values),
      });
      options.onSuccess && options.onSuccess(values);
    } catch (e: any) {
      if (options.raiseError || e instanceof APIError)
        formikHelpers.setErrors(e.errors as FormikErrors<T>);

      if (options.raiseError) throw e; // requires consumer try catch

      if (e instanceof APIError) {
        if (e.errors.detail) {
          show({
            title: Array.isArray(e.errors.detail)
              ? e.errors.detail[0]
              : e.errors.detail,
            type: "error",
          });
        }
      } else {
        show({
          title: t("Something went wrong, try again"),
          type: "error",
        });
      }
    }
  };
}
